import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import { number } from "prop-types";
import { useCallback, useEffect, useState } from "react";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import WButton from "../wbutton/WButton";

/* eslint-disable-next-line */
export interface LBoxedListProps {
  boxTitle?: string;
  boxText: string; //rich text
  listTitle?: string;
  boxCards?: {
    title: string;
    imgUrl?: string;
    altTag?: string;
    text?: string;
    showMoreText?: string;
  }[];
  bottomText?: string; // rich text
}

export function LBoxedList(props: LBoxedListProps) {
  const truncateCards = props?.boxCards && props?.boxCards?.length > 5;
  const [showMoreCards, setShowMoreCards] = useState(false);
  const handleShowMoreCards = useCallback(() => {
    setShowMoreCards((prevState) => !prevState);
  }, []);

  const [expandedCard, setExpandedCard] = useState<number>();
  const handleExpandCard = useCallback((index: number) => {
    setExpandedCard(index);
  }, []);

  return (
    <div className="flex flex-col gap-5 p-4 rounded-md bg-eklight">
      {props.boxTitle && (
        <div className="text-xl font-extrabold text-ekgreen">
          {props?.boxTitle}
        </div>
      )}
      <div className="markdown-list">
        <ReactMarkdown>{props.boxText}</ReactMarkdown>
      </div>
      {props?.listTitle && (
        <div className="text-lg font-extrabold ">{props?.listTitle}</div>
      )}

      {props?.boxCards && (
        <div className="space-y-5">
          <div
            className={clsx([
              showMoreCards
                ? "h-auto overflow-visible"
                : "max-h-[400px]  overflow-hidden",
              "space-y-5",
            ])}
          >
            <div className="flex flex-col gap-5">
              {props?.boxCards?.map((card, index) => {
                return (
                  <div
                    onClick={() =>
                      card?.showMoreText ? handleExpandCard(index) : undefined
                    }
                    key={index}
                    className={clsx([
                      card?.showMoreText &&
                        expandedCard !== index &&
                        "cursor-pointer",
                      "flex flex-col gap-3 p-5 bg-white rounded-lg shadow-sm",
                    ])}
                  >
                    <div className="text-lg font-extrabold">{card?.title}</div>
                    <div className="flex items-center gap-3">
                      {card?.imgUrl && (
                        <img
                          src={card?.imgUrl}
                          alt={card?.altTag}
                          className="object-cover w-8 h-8 rounded-full"
                        />
                      )}

                      <div>{card?.text}</div>
                    </div>
                    {expandedCard === index && (
                      <AnimatePresence>
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                        >
                          {card?.showMoreText && (
                            <ReactMarkdown>{card?.showMoreText}</ReactMarkdown>
                          )}
                        </motion.div>
                      </AnimatePresence>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          {truncateCards && (
            <WButton
              type="primary"
              text={showMoreCards ? "Vezi mai puțin" : "Vezi mai mult"}
              className="w-full"
              onClick={handleShowMoreCards}
            />
          )}
          {props?.bottomText && (
            <ReactMarkdown>{props?.bottomText}</ReactMarkdown>
          )}
        </div>
      )}
    </div>
  );
}

export default LBoxedList;
